export const isActive = (job) => job?.state == 'active';
